export { default as Copy } from "./Copy";
export { default as Replicate } from "./Replicate";
export { default as Cube } from "./Cube";
export { default as Cut } from "./Cut";
export { default as Error } from "./Error";
export { default as Redo } from "./Redo";
export { default as Undo } from "./Undo";
export { default as Facebook } from "./Facebook";
export { default as Google } from "./Google";
export { default as InsertRowAbove } from "./InsertRowAbove";
export { default as InsertRowBelow } from "./InsertRowBelow";
export { default as Paiment } from "./Paiment";
export { default as Paste } from "./Paste";
export { default as Price } from "./Price";
export { default as Rubk } from "./Rubk";
export { default as Task } from "./Task";
export { default as ArrowLeft } from "./ArrowLeft";
export { default as ArrowRight } from "./ArrowRight";
export { default as ArrowUp } from "./ArrowUp";
export { default as ArrowDown } from "./ArrowDown";
export { default as Corte } from "./Corte";
export { default as SelectSimilar } from "./SelectSimilar";
export { default as CompareBlack } from "./CompareBlack";
export { default as Ruler } from "./Ruler";
export { default as Right } from "./Right";
export { default as Formula } from "./Formula";



// WEBPACK FOOTER //
// ./src/common/icons/index.tsx